((global, factory) => {
  "use strict";
  const api = factory();
  if (typeof module !== "undefined" && module.exports) module.exports = api;
  if (global) global.KixboxOutfitSizeOrder = api;
})(typeof globalThis !== "undefined" ? globalThis : this, () => {
  "use strict";
  const apparelRanks = Object.freeze({
    XXXS: 10, "3XS": 10,
    XXS: 20, "2XS": 20,
    XS: 30,
    S: 40,
    M: 50,
    L: 60,
    XL: 70, "1XL": 70,
    XXL: 80, "2XL": 80,
    XXXL: 90, "3XL": 90,
    "4XL": 100,
    "5XL": 110,
    "6XL": 120,
  });
  const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: "base" });
  const normalize = (label) => String(label || "").trim().toUpperCase().replace(/\s+/g, "");

  function sizeKey(label) {
    const normalized = normalize(label);
    const numeric = normalized.match(/^\d+(?:[.,]\d+)?$/);
    if (numeric) return { group: 0, rank: Number(normalized.replace(",", ".")) };
    if (Object.prototype.hasOwnProperty.call(apparelRanks, normalized)) {
      return { group: 1, rank: apparelRanks[normalized] };
    }
    return { group: 2, rank: 0 };
  }

  function compareLabels(left, right) {
    const leftKey = sizeKey(left);
    const rightKey = sizeKey(right);
    if (leftKey.group === rightKey.group && leftKey.group < 2) {
      return leftKey.rank - rightKey.rank || collator.compare(String(left), String(right));
    }
    if (leftKey.group !== rightKey.group) return leftKey.group - rightKey.group;
    return collator.compare(String(left), String(right));
  }

  function sortLabels(labels) {
    return labels
      .map((label, index) => ({ label, index }))
      .sort((left, right) => compareLabels(left.label, right.label) || left.index - right.index)
      .map(({ label }) => label);
  }

  return Object.freeze({ compareLabels, sortLabels });
});
